import { TagToComponentMap } from "nwon-html-to-react";

/**
 * The Footnote area automatically get a headline attached.
 */
export const mappedDivs: TagToComponentMap = {
  div: ({ children, attributes }) => {
    return <div {...attributes}>{children}</div>;
  },
};
